export default __webpack_public_path__ + "static/media/speciality_id_4.7ab1723d.png";